import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Button } from "primereact/button";
import { useRBAC } from "../../hooks/RBACContext";
import { WRITE_ACCESS_CTA, FN_SHIFT_KEY_MAPPING } from "../../utils/Constants";
import { useModal } from "../../hooks/ModalContext";
import { confirmationModalObject } from "../Modal/ConfirmationModal.class";
import { dispatchBackBtnTriggeredEvent, isBackBtnKey } from "../../utils/UtilFunctions";

const FunctionKeys = ({ keyFunc, keyName }) => {
  const handleKeyDownRef = useRef();
  const { writeAccess } = useRBAC();
  const { isModalVisible } = useModal();
  useEffect(() => {
    handleKeyDownRef.current = (event) => {
      let { key, shiftKey } = event;

      if (shiftKey) {
        key = FN_SHIFT_KEY_MAPPING[key];
      }  

      const { isConfirmationModalOpen } = confirmationModalObject;
      if (keyFunc[key] && !isModalVisible && !isConfirmationModalOpen) {
        event.preventDefault();
        if (isBackBtnKey(keyName, key) && event.target) {
          dispatchBackBtnTriggeredEvent();
        }
        keyFunc[key](event);
      }
    };

    const handleKeyDown = (event) => handleKeyDownRef.current(event);
    window?.self?.focus()
    window.addEventListener("keydown", handleKeyDown);
   
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [keyFunc, isModalVisible]);

  // Ensure keyName is an object
  if (typeof keyName !== "object" || keyName === null) {
    console.error("keyName should be an object");
    return null;
  }

  return (
    <div className="action-cta-container">
      {Object.keys(keyName).map((key) => {
        // console.log("keys", keyName[key]);
        if (
          !writeAccess &&
          WRITE_ACCESS_CTA.some((label) =>
            keyName[key].toUpperCase().includes(label)
          )
        ) {
          return null;
        }

        // console.log("keys", keyName[key]);
        return (
          <Button
            key={key}
            id={keyName[key]}
            onClick={() => {
              if (isBackBtnKey(keyName, key)) {
                dispatchBackBtnTriggeredEvent();
              }
              keyFunc[key]();
            }}
            title={key}
            label={keyName[key]}
            tooltip={key}
            tooltipOptions={{ position: "top" }}
            severity="secondary"
          />
        );
      })}
    </div>
  );
};

FunctionKeys.propTypes = {
  keyFunc: PropTypes.objectOf(PropTypes.func).isRequired,
  keyName: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default FunctionKeys;
